{
  "fr": {
    "models": {
      "name": "Vaisseaux",
      "model": {
        "metrics": {
          "base": "Base",
          "crew": "Équipage",
          "info": "Info",
          "levels": "Niveaux",
          "speed": "Vitesse"
        },
        "focus": "Spécialisation",
        "classification": "Classification",
        "size": "Taille",
        "beam": "Largeur",
        "cargo": "Cargaison",
        "crew": "Équipage",
        "speed": "Vitesse",
        "minCrew": "Équipage min.",
        "maxCrew": "Équipage max.",
        "scmSpeed": "SCM Speed",
        "maxSpeed": "Vitesse max.",
        "scm": "SCM",
        "max": "Max",
        "groundMaxSpeed": "Vitesse max.",
        "groundReverseSpeed": "Vitesse de recul",
        "pitch": "Pitch",
        "yaw": "Yaw",
        "roll": "Roll",
        "price": "Prix",
        "groundAcceleration": "Accélération",
        "groundDecceleration": "Décélération",
        "scmSpeedAcceleration": "Zéro à SCM",
        "scmSpeedDecceleration": "SCM à Zéro",
        "compare": {
          "groundMaxSpeed": "Vitesse au sol max.",
          "groundReverseSpeed": "Vitesse de recul au sol",
          "groundAcceleration": "Accélération au sol",
          "groundDecceleration": "Décélération au sol"
        },
        "quantumFuelTankSize": "Carburant Quantum",
        "hydrogenFuelTankSize": "Carburant",
        "pledgePrice": "Prix de Pledge",
        "height": "Hauteur",
        "length": "Longueur",
        "mass": "Masse",
        "manufacturer": "Fabricant",
        "hardpoints": "Points d'attache",
        "weapons": "Armes",
        "equipment": "Équipement",
        "variants": "Variantes",
        "productionStatus": "Statut de production",
        "propulsion": "Propulsion",
        "modular": "Modulaire",
        "soldAt": "Vendu à ?",
        "rentalAt": "Loué à ?",
        "lastUpdatedAt": "Dernière mise à jour ?",
        "loaners": "Prêts",
        "paints": "Peintures",
        "modules": "Modules",
        "modulePackages": "Paquets de modules",
        "upgrades": "Kits d'amélioration",
        "brochure": "Brochure",
        "onSale": "En vente",
        "salesPage": "Page de vente",
        "addons": "Modules et kits d'amélioration",
        "productionStatuses": {
          "notAvailable": "N/A",
          "ready": "Prêt pour le hangar",
          "announced": "Annoncé"
        }
      }
    }
  }
}
